import { render } from "./icon-download.svg?vue&type=template&id=dcffa2fa&inline"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__